import { CiCalendarDate } from "react-icons/ci";

const CampaignPaymentInfo = ({ campaignData }) => {
  const convertDate = (dateStr) => {
    const date = new Date(dateStr);

    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    return formattedDate;
  };
  return (
    <div className="row campaign_budget">
      <div className="col-6 mt-4 desk_hide">
        <div className="card">
          <div className="icon">
            <CiCalendarDate />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="light_text mt-3">Campaign Start Date</p>
              <p className="card_big_text">
                {convertDate(campaignData?.campaignStartDate)}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-6 mt-4 desk_hide">
        <div className="card">
          <div className="icon">
            <CiCalendarDate />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="light_text mt-3">Campaign End Date</p>
              <p className="card_big_text">
                {convertDate(campaignData?.campaignEndDate)}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="col-md-6 mt-2">
        <div className="card">
          <div className="icon">
            <GiTakeMyMoney />
          </div>
          <p className="light_text mt-3">Deliverables</p>
          <p className="card_big_text">{campaignData?.paymentTerms}</p>
        </div>
      </div> */}
      <div className="col-md-12 mt-4 mob_hide">
        <div className="card">
          <div className="icon">
            <CiCalendarDate />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="light_text mt-3">Campaign Start Date</p>
              <p className="card_big_text">
                {convertDate(campaignData?.campaignStartDate)}
              </p>
            </div>
            <div>
              <p className="light_text mt-3">Campaign End Date</p>
              <p className="card_big_text">
                {convertDate(campaignData?.campaignEndDate)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignPaymentInfo;
